export default "__VITE_ASSET__mdG76$6M__"